import axios from 'axios';

const publicFolderAxiosClient = axios.create({
  baseURL: '/',
});

export default publicFolderAxiosClient;
